// @preval
// This file needs to be a JavaScript file using CommonJS to work with preval
// preval lets us do the stuff we'd normally do in Node with CommonJS at build time
// we're using preval because we import tokens into Fuegokit React as a module

// Cache bust: Jul 19 2023 9:34:35 GMT-0600 (This file is cached by the system's deployment tooling, so you'll need update this timestamp to rebuild this file)

// THESE CAN BE SAFELY REMOVED, LEAVING AS A REFERENCE DURING MIGRATION - M.O., 3/13/2024
// const {default: styles} = require('../temporary/styles/dist/js')
// const {default: colors} = require('@fuegokit/tokens/dist/js/cjs/atlassian/colors')
// const {default: typography} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/typography')
// const {default: radiiValues} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/radii')
// const {default: spacing} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/size')

const {dark, light} = require('@fuegokit/tokens/tokens-next-gen-private/js/cjs/atlassian/colors')
const {typography: typographyTokens} = require('@fuegokit/tokens/tokens-next-gen-private/js/cjs/atlassian/typography')
const {radii: radiiTokens} = require('@fuegokit/tokens/tokens-next-gen-private/js/cjs/atlassian/radii')
const sizeTokens = require('@fuegokit/tokens/tokens-next-gen-private/js/cjs/atlassian/size')

const typography = typographyTokens.default
const {size} = sizeTokens.size.default
const spaceObject = sizeTokens.size.default.space
const colors = {
  light: light.default,
  dark: dark.default
}

const {partitionColors, fontStack: createFontStack, omitScale} = require('./theme-utils')

const colorSchemes = Object.entries(colors).reduce((acc, [name, variables]) => {
  const {colors: filteredColors, shadows: filteredShadows} = partitionColors(variables)
  acc[name] = {
    colors: omitScale(filteredColors),
    shadows: omitScale(filteredShadows)
  }
  return acc
}, {})

const {fontStack, fontSizes: fontSizeObject, lineHeights, fontWeights} = typography

const fontSizes = Object.values(fontSizeObject)
const space = Object.values(spaceObject)
const radii = Object.values(radiiTokens.default.radii)

const breakpoints = ['350px', '544px', '768px', '1012px', '1280px']
const animation = {
  easeOutCubic: 'cubic-bezier(0.33, 1, 0.68, 1)'
}

const borderWidths = [0, '1px']

const handBuiltFonts = {
  normal: createFontStack([
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji'
  ]),
  mono: createFontStack(['SFMono-Regular', 'Consolas', 'Liberation Mono', 'Menlo', 'Courier', 'monospace']),
  title: createFontStack([
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji'
  ])
}

// token font stacks are being incorrectly interpolated as illegal CSS string values;
// for now, just use the hand-built stacks above
const fonts = {
  normal: handBuiltFonts.normal,
  mono: handBuiltFonts.mono,
  title: handBuiltFonts.title
}

// this is a duplicate for backwards compatibility, to be removed eventually after tokens
// are stable
const fontFamily = {
  normal: handBuiltFonts.normal,
  mono: handBuiltFonts.mono,
  title: handBuiltFonts.title
}

const theme = {
  fontStack,
  fontFamily,
  animation,
  borderWidths,
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  radii,
  size,
  space,
  colorSchemes
}

module.exports = {
  theme
}
